import { useState, useEffect } from 'react';
import { apiClient } from '@/lib/api/client';

export interface Post {
  id: string
  /**
   * Derivado do título. É o que vai na URL pública.
   *
   * Opcional porque notícias criadas antes do slug existir não têm um — e a
   * navegação cai no id nesses casos, em vez de gerar um link quebrado.
   */
  slug?: string | null;
  title: string;
  authorNick: string;
  content: string;
  bannerUrl?: string;
  isPublished: boolean;
  showAsModal: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PostsResponse {
  posts: Post[];
  total: number;
  page: number;
  limit: number;
}

export function usePosts(storeId: string | undefined, page: number = 1, limit: number = 6) {
  const [posts, setPosts] = useState<Post[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!storeId) {
      setLoading(false);
      return;
    }

    const fetchPosts = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await apiClient.get<PostsResponse>(
          `/stores/${storeId}/posts/published?page=${page}&limit=${limit}`
        );

        setPosts(response.posts);
        setTotal(response.total);
      } catch (err: any) {
        console.error('Error fetching posts:', err);
        setError(err.message || 'Erro ao carregar notícias');
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [storeId, page, limit]);

  return { posts, total, loading, error };
}
